import '../settings/settings.css';
import { Button, Checkbox, Form, Input, InputNumber, Upload, message } from 'antd';
import { useEffect, useState } from 'react';
import { serverFetch, fileUrl } from '@server';
import { showError } from '@extensions/utils';

// Карточка фирмы: реквизиты + логотип/подпись; используется в Настройках и в списке фирм (суперадмин)
const CompanyForm = ({ item: itemProp, onSave, showActive = false, title }) => {
    const [form] = Form.useForm();
    const [item, setItem] = useState(itemProp);
    const [dirty, setDirty] = useState(false);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        setItem(itemProp);
        form.setFieldsValue(itemProp ?? {});
        setDirty(false);
    }, [itemProp, form]);

    const save = (values) => {
        setSaving(true);
        return onSave({ ...item, ...values })
            .then((c) => {
                setItem(c);
                form.setFieldsValue(c);
                setDirty(false);
                message.success('Сохранено');
                return c;
            })
            .catch((e) => { showError(e); throw e; })
            .finally(() => setSaving(false));
    };

    const saveImageField = (field, fileId, oldId) => {
        save({ ...form.getFieldsValue(), [field]: fileId })
            .then(() => {
                if (oldId) serverFetch(`file/${oldId}`, { method: 'DELETE' }).catch(() => { });
            })
            .catch(() => { });
    };

    const uploadImage = (field, file) => {
        if (!item?.id) return;
        const fd = new FormData();
        fd.append('files', file);
        serverFetch(`file?ownerVid=2&ownerId=${item.id}`, { method: 'POST', formData: fd })
            .then((result) => saveImageField(field, result[0].id, item[field]))
            .catch(showError);
    };

    const renderImageField = (field, label) => (
        <Form.Item label={label}>
            {item?.[field] && (
                <img src={fileUrl(item[field], true)} alt={label} style={{ maxHeight: 80, display: 'block', marginBottom: 8 }} />
            )}
            <Upload
                showUploadList={false}
                accept="image/*"
                beforeUpload={(f) => { uploadImage(field, f); return false; }}
            >
                <Button disabled={!item?.id}>{item?.[field] ? 'Заменить' : 'Загрузить'}</Button>
            </Upload>
            {item?.[field] && (
                <Button danger style={{ marginLeft: 8 }} onClick={() => saveImageField(field, null, item[field])}>
                    Удалить
                </Button>
            )}
        </Form.Item>
    );

    return (
        <div className="settings-form">
            {title && <div className="crud-table-header"><h3>{title}</h3></div>}
            <Form form={form} layout="vertical" onFinish={save} onValuesChange={() => setDirty(true)}>
                <Form.Item name="name" label="Наименование" rules={[{ required: true, whitespace: true, message: 'Укажите наименование' }]}>
                    <Input />
                </Form.Item>
                <div className="settings-form-row">
                    <Form.Item name="email" label="Email"><Input /></Form.Item>
                    <Form.Item name="phone" label="Телефон"><Input /></Form.Item>
                </div>
                <div className="settings-form-row">
                    <Form.Item name="address" label="Адрес"><Input /></Form.Item>
                    <Form.Item name="gmt" label="Часовой пояс" style={{ flex: '0 0 140px' }}>
                        <InputNumber addonBefore="GMT" min={-12} max={14} style={{ width: '100%' }} />
                    </Form.Item>
                </div>
                <Form.Item name="description" label="Описание"><Input.TextArea autoSize={{ minRows: 3, maxRows: 10 }} /></Form.Item>
                {showActive && (
                    <Form.Item name="active" valuePropName="checked"><Checkbox>Активна</Checkbox></Form.Item>
                )}
                <h4>Реквизиты для счёта</h4>
                <Form.Item name="fullName" label="Полное наименование"><Input /></Form.Item>
                <div className="settings-form-row">
                    <Form.Item name="inn" label="ИНН"><Input /></Form.Item>
                    <Form.Item name="kpp" label="КПП"><Input /></Form.Item>
                </div>
                <Form.Item name="bank" label="Банк">
                    <Input placeholder="Омское отделение № 8634 ПАО Сбербанк, г. Омск" />
                </Form.Item>
                <div className="settings-form-row">
                    <Form.Item name="bik" label="БИК"><Input /></Form.Item>
                    <Form.Item name="ks" label="Корр. счёт"><Input /></Form.Item>
                </div>
                <Form.Item name="rs" label="Расч. счёт"><Input /></Form.Item>
                <div className="settings-form-row">
                    {renderImageField('logoFileId', 'Логотип')}
                    {renderImageField('signFileId', 'Подпись/печать')}
                </div>
                {!item?.id && (
                    <div style={{ color: '#999', marginBottom: 12 }}>Сохраните фирму, чтобы загрузить изображения</div>
                )}
                <Button type="primary" htmlType="submit" loading={saving} disabled={!dirty}>Сохранить</Button>
            </Form>
        </div>
    );
};

export default CompanyForm;
